
import request from '@/api/http.js'

//获取拥有某种权限的用户
export function peruser(data) {
    return request({
        url: '/permission/users',
        method: 'get',
        params: data,
    })
}

//设置导入/下载excel权限
export function permission(data) {
    return request({
        url: '/user/permission',
        method: 'post',
        data,
    })
}

//获取所有账号
export function getUsers(data) {
    return request({
        url: 'users',
        method: 'get',
        params: data,
    })
}

//添加用户
export function addDivUser(data) {
    return request({
        url: 'user/addDivUser',
        method: 'post',
        data,
    })
}

//用户信息
export function user(data) {
    return request({
        url: 'user',
        method: 'get',
        params: data,
    })
}
// 列出系统支持所有的权限
export function permissions(data) {
    return request({
        url: 'api/permission/list',
        method: 'get',
        params: data,
    })
}

//角色列表
export function rolesall() {
    return request({
        url: 'roles',
        method: 'get',
        params: '',
    })
}

//新增角色
export function newaddRoles(data) {
    return request({
        url: 'role/add',
        method: 'post',
        data,
    })
}
//删除角色
export function deleteRole(data) {
    return request({
        url: 'role/delete',
        method: 'post',
        data,
    })
}
//编辑角色权限
export function editRole(data) {
    return request({
        url: 'role/edit',
        method: 'post',
        data,
    })
}
//编辑用户
export function userEdit(data) {
    return request({
        url: 'user/edit',
        method: 'post',
        data,
    })
}

//删除用户  
export function userDelete(data) {
    return request({
        url: 'user/delete',
        method: 'post',
        data,
    })
}

//添加管理员用户
export function addZoneUser(data) {
    return request({
        url: 'user/addZoneUser',
        method: 'post',
        data,
    })
}

//重置密码
export function resetPassword(data) {
    return request({
        url: 'user/resetPassword',
        method: 'post',
        data,
    })
}



export function getPdfToken(query) {
    return request({
        url: 'user/onceToken',
        method: 'get',
        params: query,
    })
}
export function changePdfToken(params) {
    return request({
        url: 'user/exchangeToken',
        method: 'post',
        data: params,
    })
}